import { z } from "zod";

export const SatelliteContactSiteSchema = z.object({
    id: z.number(),
    name: z.string(),
    website_url: z.string(),
    access_key: z.string(),
    is_active: z.boolean(),
    last_used_at: z.string().nullable(),
    submissions_count: z.number().int().min(0),
    created_at: z.string(),
    updated_at: z.string(),
});

export const SatelliteContactSiteStatsSchema = z.object({
    all_time: z.number().int().min(0),
    last_30_days: z.number().int().min(0),
    last_month: z.number().int().min(0),
    this_month: z.number().int().min(0),
});

export const SatelliteContactSiteWithStatsSchema = SatelliteContactSiteSchema.extend({
    stats: SatelliteContactSiteStatsSchema,
});

export const SatelliteContactSitesStatsResponseSchema = z.object({
    aggregate: SatelliteContactSiteStatsSchema,
    sites: z.array(SatelliteContactSiteWithStatsSchema),
});

export const CreateSatelliteContactSiteRequestSchema = z.object({
    name: z.string().min(1),
    website_url: z.string().min(1),
    access_key: z.string().min(1).optional(),
    is_active: z.boolean().optional(),
});

export const UpdateSatelliteContactSiteRequestSchema = z.object({
    name: z.string().min(1).optional(),
    website_url: z.string().min(1).optional(),
    access_key: z.string().min(1).optional(),
    is_active: z.boolean().optional(),
});

export type SatelliteContactSite = z.infer<typeof SatelliteContactSiteSchema>;
export type SatelliteContactSiteStats = z.infer<typeof SatelliteContactSiteStatsSchema>;
export type SatelliteContactSiteWithStats = z.infer<typeof SatelliteContactSiteWithStatsSchema>;
export type SatelliteContactSitesStatsResponse = z.infer<typeof SatelliteContactSitesStatsResponseSchema>;
export type CreateSatelliteContactSiteRequest = z.input<typeof CreateSatelliteContactSiteRequestSchema>;
export type UpdateSatelliteContactSiteRequest = z.input<typeof UpdateSatelliteContactSiteRequestSchema>;
